import React from 'react'
import { Box, CheckBox } from '@usap/uicomponents'

const ComputeQtyCheckboxWMO = props => {
  const {
    isMultiplePart,
    itemOrderId,
    showCheckBox,
    handleChange,
    qtyToCompute,
    multipleItemsPresent,
    setIsItemSelected,
  } = { ...props }

  const changeHandler = (e) => {
    setIsItemSelected(e.target.checked)
    handleChange(e);
  }

  return (
    <>
      {
        multipleItemsPresent
          ?
          <Box
            alignSelf="start"
            justify="center"
            margin={{ horizontal: '10px', top: '32px', bottom: '10px' }}
            width="18px"
            height="18px"
          >
            {isMultiplePart && showCheckBox && (
              <CheckBox
                name={`RMA${itemOrderId}`}
                onChange={changeHandler}
                value={qtyToCompute}
                fill={true}
              />
            )}
          </Box>
          :
          null
      }


    </>
  )
}

export default ComputeQtyCheckboxWMO
